// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bbID","type":"styles_type__1dYAN","choices":"styles_choices__3B62l"};